import { organisationPermissionsData } from './organisationPermissions'
import { organisationPermissions } from './organisationPermissions'
import { userPermissionsData } from './userPermissions'
import { userPermissions } from './userPermissions'

export const allPermissions = [...organisationPermissions, ...userPermissions] as const
export const allPermissionsData = { ...organisationPermissionsData, ...userPermissionsData }
